import { useState } from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import Seo from "@/components/Seo";

const Contact = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);

    // Open the user's email client with a prefilled message to our real inbox.
    const subject = encodeURIComponent(`CardCombiner contact from ${name}`);
    const body = encodeURIComponent(
      `Name: ${name}\nEmail: ${email}\n\n${message}`
    );
    window.location.href = `mailto:axel@lumbridgeholding.se?subject=${subject}&body=${body}`;

    setTimeout(() => {
      toast.success("Your email client should now be open. Send the message to reach us.");
      setIsSubmitting(false);
    }, 500);
  };

  return (
    <div className="min-h-screen bg-[#f1f1f1] flex flex-col">
      <Seo
        title="Contact CardCombiner – Get in Touch"
        description="Questions, feedback, or feature requests for CardCombiner? Email Axel directly at axel@lumbridgeholding.se. Fast, personal replies."
        path="/contact"
      />
      <Navbar />
      <div className="max-w-4xl mx-auto p-4 md:p-8 flex-grow">
        <div className="bg-white p-6 md:p-8 rounded-[16px] md:rounded-[24px] shadow-lg">
          <h1 className="text-3xl md:text-4xl font-bold mb-6 text-[#6B4EE6]">Contact Us</h1>
          
          <div className="grid md:grid-cols-2 gap-8">
            <div>
              <h2 className="text-xl md:text-2xl font-semibold mb-3 text-[#6B4EE6]">
                Get in Touch
              </h2>
              <p className="text-gray-700 mb-4">
                Have questions, suggestions, or feedback? We'd love to hear from you! Fill out the form 
                and we'll get back to you as soon as possible.
              </p>
              
              <div className="space-y-4">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full bg-[#E5DEFF] flex items-center justify-center text-[#6B4EE6]">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                      <path d="M22 6l-10 7L2 6" />
                    </svg>
                  </div>
                  <a
                    href="mailto:axel@lumbridgeholding.se"
                    className="text-gray-700 hover:text-[#6B4EE6] underline"
                  >
                    axel@lumbridgeholding.se
                  </a>
                </div>
                <p className="text-sm text-gray-600">
                  CardCombiner is operated by Lumbridge Holding, based in
                  Stockholm, Sweden. We typically reply to email within 1–2
                  business days.
                </p>
              </div>
            </div>
            
            <div>
              <form onSubmit={handleSubmit} className="space-y-4">
                <div>
                  <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1">Name</label>
                  <input
                    id="name"
                    type="text"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#6B4EE6] focus:border-transparent"
                    required
                  />
                </div>
                
                <div>
                  <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">Email</label>
                  <input
                    id="email"
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#6B4EE6] focus:border-transparent"
                    required
                  />
                </div>
                
                <div>
                  <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-1">Message</label>
                  <textarea
                    id="message"
                    rows={5}
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#6B4EE6] focus:border-transparent"
                    required
                  ></textarea>
                </div>
                
                <Button 
                  type="submit" 
                  className="w-full bg-[#6B4EE6] hover:bg-[#5A3DD3]" 
                  disabled={isSubmitting}
                >
                  {isSubmitting ? "Sending..." : "Send Message"}
                </Button>
              </form>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Contact;
